import { z } from "zod";

export const CreateObservationFormSchema = z.object({
  observation: z
    .string()
    .min(10, { message: "A observação deve ter no mínimo 10 caracteres." })
    .max(500, { message: "A observação não pode exceder 500 caracteres." }),

  chat_message_id: z
    .string()
    .min(1, { message: "ID da mensagem é obrigatório." }),
});

export type CreateObservationData = z.infer<typeof CreateObservationFormSchema>;
